import { Button, Card, Checkbox, Col, Form, message, Row } from "antd";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import libraryApi from "../../../../api/libraryApi";
import InputField from "../../../../components/InputField";
import InputNumberWrap from "../../../../components/InputNumber";
import Loading from "../../../../components/Loading";
import TextAreaField from "../../../../components/TextAreaField";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { formItemLayoutSm } from "../../../../utils/constants";
import { messages } from "../../../../utils/messages";
import { ConvertSlug } from "../../../../utils/functions/convertSlug";

interface CategoryLibraryFormProps {
  type: number;
}
const CategoryLibraryForm: FC<CategoryLibraryFormProps> = ({ type }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading, isFetching } = useQuery(
    ["library_categories", id],
    () => libraryApi.getCateDetails(id),
    { enabled: type === 2 }
  );

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const mutationEdit = useMutation(libraryApi.editCate, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        queryClient.invalidateQueries("library_categories");
        navigate(appRoutes.LIBRARY.CATEGORIES.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  const mutationAdd = useMutation(libraryApi.addCate, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.addSuccess);
        queryClient.invalidateQueries("create-category_categories");
        navigate(appRoutes.LIBRARY.CATEGORIES.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const onSubmit = (dt: any) => {
    if (type === 2)
      mutationEdit.mutate({
        id: id,
        data: { ...dt, hienthi: dt?.hienthi ?? false },
      });
    if (type === 1)
      mutationAdd.mutate({ ...dt, hienthi: dt?.hienthi ?? false });
  };

  return (
    <PageWrap
      title="Tin quan trọng"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Danh mục</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading || isFetching ? (
              <Loading />
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayoutSm}>
                  <InputField
                    label="Tên"
                    name="ten_vi"
                    control={control}
                    defaultValue={data?.data?.ten_vi}
                    setValue={setValue}
                    errorMsg={errors?.ten_vi?.message}
                    rules={{
                      required: "Vui lòng nhập tên",
                    }}
                  />
                  <InputField
                    label="Tên title"
                    name="ten_en"
                    control={control}
                    defaultValue={data?.data?.ten_en}
                    setValue={setValue}
                  />
                  <InputField
                    label="Title"
                    name="title_vi"
                    control={control}
                    defaultValue={data?.data?.title_vi}
                    setValue={setValue}
                    onChange={(e: any) => {
                      setValue("slug_vi", ConvertSlug(e.target.value));
                    }}
                  />
                  <InputField
                    label="Slug"
                    name="slug_vi"
                    control={control}
                    defaultValue={data?.data?.slug_vi}
                    setValue={setValue}
                    errorMsg={errors?.slug_vi?.message}
                    rules={{
                      required: "Vui lòng nhập slug",
                      minLength: {
                        value: 10,
                        message: "Vui lòng nhập trên 10 kí tự",
                      },
                    }}
                  />
                  <InputField
                    label="keywords"
                    name="keywords_vi"
                    control={control}
                    defaultValue={data?.data?.keywords_vi}
                    setValue={setValue}
                  />
                  <TextAreaField
                    label="Description"
                    name="description_vi"
                    control={control}
                    defaultValue={data?.data?.description_vi}
                  />
                  <InputNumberWrap
                    label="STT"
                    name="stt"
                    control={control}
                    defaultValue={data?.data?.stt ?? 1}
                    onBlur={(e: any) => {
                      if (e.target.value === "") setValue("stt", 1);
                    }}
                    min={1}
                  />
                  <Form.Item className="checkbox">
                    <Row>
                      <Col xs={24} sm={20}>
                        <Checkbox
                          defaultChecked={data?.data?.hienthi}
                          name="hienthi"
                          onClick={(e: any) => {
                            setValue("hienthi", e.target.checked);
                          }}
                        />
                        &nbsp;Hiển thị
                      </Col>
                    </Row>
                  </Form.Item>
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() =>
                          navigate(appRoutes.LIBRARY.CATEGORIES.LIST)
                        }
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default CategoryLibraryForm;
